import { render, staticRenderFns } from "./tab3.vue?vue&type=template&id=0512fe22&scoped=true&"
import script from "./tab3.vue?vue&type=script&lang=js&"
export * from "./tab3.vue?vue&type=script&lang=js&"
import style0 from "./tab3.vue?vue&type=style&index=0&id=0512fe22&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512fe22",
  null
  
)

export default component.exports